wbApp.controller('FranchisesEmployeesCtrl', ['$scope', '$modal', 'franchiseSvc', 'tenantSettingSvc',
function ($scope, $modal, franchiseSvc, tenantSettingSvc) {

    $scope.employees = [];

    var selectedFranchise;

    $scope.requireTeacherFranchiseLicenses = tenantSettingSvc.settings.requireTeacherFranchiseLicenses;

    $scope.$on('franchiseSelectionChanged', function (e, newFranchise) {
        if (newFranchise) {
            selectedFranchise = newFranchise;
            $scope.employees = franchiseSvc.getEmployeesByTenant(selectedFranchise.franchiseTenantAlias);
        } else {
            $scope.employees = [];
        }
    });

    $scope.filterOptions = {
        filterText: ""
    };

    $scope.gridOptions = {
        sortInfo: { fields: ['fullName'], directions: ['dsc'] },        
        columnDefs: [
            { field: 'fullName', displayName: "TXT_HUMAN_NAME", sort: 'locale' },
            { field: 'franchiseActive', displayName: "TXT_LBL_ACTIVE", cellFilter: 'checkmark', width: '70px' }
        ]
    };


    $scope.onRowEdit = function (employee) {
        detailDialogPromise.$promise.then(function () {
            detailDialogPromise.$scope.model = angular.copy(employee);
            detailDialogPromise.$scope.selectedFranchise = selectedFranchise;
            detailDialogPromise.$scope.onSaveSuccess = function (newData) {
                employee.employeeDTO = newData.employeeDTO;
                $scope.$emit('franchiseEmployeeUpdated', employee);
            }
            detailDialogPromise.show();
        });
    }

    var detailDialogPromise = $modal({
        templateUrl: 'franchise/franchises-tabs/employee-detail.html',
        show: false,
        scope: $scope.$new()
    });

}]);